var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSettings = function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6 7.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.7 7.5a.825.825 0 0 0 .165.91l.03.03A1.001 1.001 0 1 1 8.48 9.855l-.03-.03a.825.825 0 0 0-.91-.165.83.83 0 0 0-.5.755v.085a1 1 0 1 1-2 0v-.045A.825.825 0 0 0 4.5 9.7a.825.825 0 0 0-.91.165l-.03.03A1.001 1.001 0 1 1 2.145 8.48l.03-.03a.825.825 0 0 0 .165-.91.83.83 0 0 0-.755-.5H1.5a1 1 0 0 1 0-2h.045A.825.825 0 0 0 2.3 4.5a.825.825 0 0 0-.165-.91l-.03-.03A1 1 0 1 1 3.52 2.145l.03.03a.825.825 0 0 0 .91.165h.04a.83.83 0 0 0 .5-.755V1.5a1 1 0 0 1 2 0v.045a.83.83 0 0 0 .5.755.825.825 0 0 0 .91-.165l.03-.03A1 1 0 1 1 9.855 3.52l-.03.03a.825.825 0 0 0-.165.91v.04a.83.83 0 0 0 .755.5h.085a1 1 0 1 1 0 2h-.045a.83.83 0 0 0-.755.5"
  })));
};
export default SvgSettings;